import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { Observable } from 'rxjs';
import { ImageElementResponse } from './attachment.interface';

/**
 * Handles all attachments/uploads.
 */
@Injectable({
  providedIn: 'root'
})
export class AttachmentService {

  constructor(
    private apiService: ApiService
  ) { }

  /**
   * Upload image for use in elements (`element.value`).
   *
   * @param filename The images filename.
   * @param blob The file as a base64 blob.
   * @returns Observable with location data.
   */
  public uploadImageElement(filename: string, blob: string): Observable<ImageElementResponse> {
    return this.apiService.uploadElementImage(filename, blob);
  }
}
